var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-title-container"},[_c('a-breadcrumb',{staticClass:"breadcrumb",attrs:{"routes":_vm.routes},scopedSlots:_vm._u([{key:"itemRender",fn:function(ref){
var route = ref.route;
var params = ref.params;
var routes = ref.routes;
var paths = ref.paths;
return [(routes.indexOf(route) === routes.length - 1)?_c('span',[_vm._v("\n        "+_vm._s(route.name)+"\n      ")]):_c('router-link',{attrs:{"to":("/" + (paths.join('/')))}},[_vm._v("\n        "+_vm._s(route.name)+"\n      ")])]}}])}),_c('h2',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }